import { render } from "./App.vue?vue&type=template&id=8bae9a06&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "../public/css/dcp-base.css?vue&type=style&index=0&id=8bae9a06&lang=css&scoped=true&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bae9a06"]])

export default __exports__